import { Component, OnInit } from '@angular/core';
import { UIRouter }          from '@uirouter/core';

import { IntelligenceInspectionStatsModel } from '../typings/intelligence.inspection-stats';
import { IntelligenceService }              from '../intelligence.service';
import { TableService }                     from '../../table/table.service';

const DEFAULT_STATS : IntelligenceInspectionStatsModel = {
  approved      : 0,
  drafts        : 0,
  finalized     : 0,
  finalized_work: 0,
  refused       : 0,
  requested     : 0
};

@Component({
  selector   : 'wor-intelligence-inspections-tab',
  template: require('./intelligence.inspections-tab.component.html')
})
export class InspectionsTabComponent implements OnInit {
  public error   : boolean = false;
  public loading : boolean = true;

  public stats : IntelligenceInspectionStatsModel = { ...DEFAULT_STATS };

  private loadGeneration : number = 0;

  constructor (
    public intelligenceService : IntelligenceService,
    private router             : UIRouter,
    private tableApi           : TableService
  ) {}

  ngOnInit () : void {
    this.load();
  }

  load () : void {
    const generation = ++this.loadGeneration;

    this.error = false;
    this.loading = true;

    this.intelligenceService.getInspectionStats()
    .then(( stats : IntelligenceInspectionStatsModel ) => {
      if ( generation !== this.loadGeneration ) {
        return;
      }

      this.stats = { ...DEFAULT_STATS, ...( stats || {} ) };
    })
    .catch(() => {
      if ( generation === this.loadGeneration ) {
        this.error = true;
      }
    })
    .finally(() => {
      if ( generation === this.loadGeneration ) {
        this.loading = false;
      }
    });
  }

  view ( status : string ) : void {
    this.tableApi.updateCachedFilters('transactionCenterInspections', { status });
    this.router.stateService.go('app.transaction-center.inspections');
  }
}
